/**
 * Класс для работы с профилем клиента
 */
const Profile = {
	// ID модуля профиля (из БД modules)
	moduleId: 4,

	// Таймер для повторной отправки SMS
	phoneCountdownTimer: null,
	phoneCountdownValue: 60,

	/**
	 * Инициализация
	 */
	init: function() {
		// Инициализация flatpickr для даты рождения
		const birthdayInput = document.getElementById('profile-birthday');
		if (birthdayInput && window.flatpickr) {
			flatpickr(birthdayInput, {
				dateFormat: 'd.m.Y',
				maxDate: new Date(),
				locale: {
					firstDayOfWeek: 1
				}
			});
		}

		// Инициализация полей ввода кода в попапе телефона
		this.initPhoneCodeInputs();

		// Маска для телефона в попапе
		this.initPhoneMask();
	},

	/**
	 * Маска для ввода телефона
	 */
	initPhoneMask: function() {
		const phoneInput = document.getElementById('new-phone-input');
		if (!phoneInput) return;

		phoneInput.addEventListener('input', function(e) {
			let value = e.target.value.replace(/\D/g, '');

			if (value.length > 10) {
				value = value.slice(0, 10);
			}

			let formatted = '';
			if (value.length > 0) {
				formatted = '(' + value.substring(0, 3);
			}
			if (value.length > 3) {
				formatted += ') ' + value.substring(3, 6);
			}
			if (value.length > 6) {
				formatted += '-' + value.substring(6, 8);
			}
			if (value.length > 8) {
				formatted += '-' + value.substring(8, 10);
			}

			e.target.value = formatted;
		});
	},

	/**
	 * Инициализация полей ввода 4-значного кода для телефона
	 */
	initPhoneCodeInputs: function() {
		const container = document.getElementById('phone-step-2');
		if (!container) return;

		const inputs = container.querySelectorAll('.popup-change__code-input');
		const verifyBtn = document.getElementById('phone-verify-btn');

		inputs.forEach((input, index) => {
			input.addEventListener('input', (e) => {
				const value = e.target.value.replace(/[^0-9]/g, '');
				e.target.value = value;

				if (value && index < inputs.length - 1) {
					inputs[index + 1].focus();
				}

				// Проверяем заполненность всех полей
				let allFilled = true;
				inputs.forEach(inp => {
					if (!inp.value) allFilled = false;
				});

				if (verifyBtn) {
					verifyBtn.disabled = !allFilled;
				}
			});

			input.addEventListener('keydown', (e) => {
				if (e.key === 'Backspace' && !e.target.value && index > 0) {
					inputs[index - 1].focus();
				}
			});

			input.addEventListener('paste', (e) => {
				e.preventDefault();
				const paste = (e.clipboardData || window.clipboardData).getData('text');
				const digits = paste.replace(/[^0-9]/g, '').split('');

				inputs.forEach((inp, i) => {
					if (digits[i]) {
						inp.value = digits[i];
					}
				});

				// Фокус на последнее заполненное поле или следующее пустое
				const lastFilled = Math.min(digits.length, inputs.length) - 1;
				if (lastFilled >= 0 && lastFilled < inputs.length - 1) {
					inputs[lastFilled + 1].focus();
				} else if (lastFilled >= 0) {
					inputs[lastFilled].focus();
				}

				// Проверяем заполненность
				let allFilled = true;
				inputs.forEach(inp => {
					if (!inp.value) allFilled = false;
				});
				if (verifyBtn) {
					verifyBtn.disabled = !allFilled;
				}
			});
		});
	},

	/**
	 * Сохранение профиля
	 */
	save: function(form) {
		const errorEl = document.getElementById('profile-form-error');
		const submitBtn = form.querySelector('[type="submit"]');

		// Очищаем ошибку
		if (errorEl) errorEl.textContent = '';

		// Убираем подсветку ошибок
		form.querySelectorAll('.error').forEach(el => el.classList.remove('error'));

		// Собираем данные формы
		const formData = new FormData(form);
		formData.append('mid', this.moduleId);
		formData.append('action', 'save');
		formData.append('mode', 'profile');

		// Блокируем кнопку
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Сохранение...';
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Сохранить изменения';
			}

			if (data.success) {
				// Показываем сообщение об успехе
				this.showSuccess('Изменения сохранены');
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Ошибка сохранения';

				// Подсветка поля с ошибкой
				if (data.field) {
					const field = form.querySelector(`[name="${data.field}"]`);
					if (field) {
						field.focus();
						field.classList.add('error');
					}
				}
			}
		})
		.catch(error => {
			console.error('Profile save error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Сохранить изменения';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	// =========================================================================
	// Смена телефона
	// =========================================================================

	/**
	 * Открыть попап смены телефона
	 */
	changePhone: function() {
		const popup = document.getElementById('popup-change-phone');
		if (!popup) return;

		// Сброс состояния
		const step1 = document.getElementById('phone-step-1');
		const step2 = document.getElementById('phone-step-2');
		if (step1) step1.classList.add('popup-change__step--active');
		if (step2) step2.classList.remove('popup-change__step--active');

		// Очистка полей
		const phoneInput = document.getElementById('new-phone-input');
		if (phoneInput) phoneInput.value = '';

		const errorEl = document.getElementById('phone-change-error');
		if (errorEl) errorEl.textContent = '';

		// Очистка полей кода
		popup.querySelectorAll('.popup-change__code-input').forEach(input => {
			input.value = '';
		});

		const codeError = document.getElementById('phone-code-error');
		if (codeError) codeError.textContent = '';

		// Показываем попап
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		// Фокус на поле ввода
		setTimeout(() => {
			if (phoneInput) phoneInput.focus();
		}, 100);
	},

	/**
	 * Закрыть попап смены телефона
	 */
	closePhonePopup: function() {
		const popup = document.getElementById('popup-change-phone');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
		this.stopPhoneCountdown();
	},

	/**
	 * Отправка кода на новый телефон
	 */
	sendPhoneCode: function() {
		const input = document.getElementById('new-phone-input');
		const errorEl = document.getElementById('phone-change-error');
		const btn = document.getElementById('phone-send-code-btn');

		if (!input) return;

		// Получаем номер (только цифры)
		let newPhone = input.value.replace(/\D/g, '');

		// Добавляем код страны если нужно
		if (newPhone.length === 10) {
			newPhone = '7' + newPhone;
		}

		// Валидация
		if (newPhone.length !== 11) {
			errorEl.textContent = 'Введите корректный номер телефона';
			return;
		}

		// Очищаем ошибку
		errorEl.textContent = '';
		btn.disabled = true;
		btn.textContent = 'Отправка...';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'request_phone_change');
		formData.append('new_phone', newPhone);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			btn.disabled = false;
			btn.textContent = 'Получить код';

			if (data.success) {
				// Переход к вводу кода
				document.getElementById('phone-step-1').classList.remove('popup-change__step--active');
				document.getElementById('phone-step-2').classList.add('popup-change__step--active');

				// Фокус на первое поле кода
				const firstCodeInput = document.querySelector('#phone-step-2 .popup-change__code-input');
				if (firstCodeInput) firstCodeInput.focus();

				// Запускаем таймер
				this.startPhoneCountdown();
			} else {
				errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Send phone code error:', error);
			btn.disabled = false;
			btn.textContent = 'Получить код';
			errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Вернуться назад в попапе телефона
	 */
	phoneStepBack: function() {
		document.getElementById('phone-step-2').classList.remove('popup-change__step--active');
		document.getElementById('phone-step-1').classList.add('popup-change__step--active');

		// Очистка полей кода
		document.querySelectorAll('#phone-step-2 .popup-change__code-input').forEach(input => {
			input.value = '';
		});

		this.stopPhoneCountdown();
	},

	/**
	 * Запуск обратного отсчёта для повторной отправки SMS
	 */
	startPhoneCountdown: function() {
		this.stopPhoneCountdown();
		this.phoneCountdownValue = 60;

		const timer = document.getElementById('phone-code-timer');
		const resend = document.getElementById('phone-code-resend');
		const countdown = document.getElementById('phone-code-countdown');

		if (timer) timer.style.display = '';
		if (resend) resend.style.display = 'none';
		if (countdown) countdown.textContent = this.phoneCountdownValue;

		this.phoneCountdownTimer = setInterval(() => {
			this.phoneCountdownValue--;
			if (countdown) countdown.textContent = this.phoneCountdownValue;

			if (this.phoneCountdownValue <= 0) {
				this.stopPhoneCountdown();
				if (timer) timer.style.display = 'none';
				if (resend) resend.style.display = '';
			}
		}, 1000);
	},

	/**
	 * Остановка таймера
	 */
	stopPhoneCountdown: function() {
		if (this.phoneCountdownTimer) {
			clearInterval(this.phoneCountdownTimer);
			this.phoneCountdownTimer = null;
		}
	},

	/**
	 * Повторная отправка кода на телефон
	 */
	resendPhoneCode: function() {
		const input = document.getElementById('new-phone-input');
		if (!input) return;

		let newPhone = input.value.replace(/\D/g, '');
		if (newPhone.length === 10) {
			newPhone = '7' + newPhone;
		}

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'request_phone_change');
		formData.append('new_phone', newPhone);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Очищаем поля кода
				document.querySelectorAll('#phone-step-2 .popup-change__code-input').forEach(input => {
					input.value = '';
				});
				document.querySelector('#phone-step-2 .popup-change__code-input')?.focus();

				// Перезапускаем таймер
				this.startPhoneCountdown();
			} else {
				const errorEl = document.getElementById('phone-code-error');
				if (errorEl) errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Resend phone code error:', error);
		});
	},

	/**
	 * Проверка кода для смены телефона
	 */
	verifyPhoneCode: function() {
		const codeInputs = document.querySelectorAll('#phone-step-2 .popup-change__code-input');
		const errorEl = document.getElementById('phone-code-error');
		const btn = document.getElementById('phone-verify-btn');

		let code = '';
		codeInputs.forEach(input => {
			code += input.value;
		});

		if (code.length !== 4) {
			errorEl.textContent = 'Введите 4-значный код';
			return;
		}

		errorEl.textContent = '';
		btn.disabled = true;
		btn.textContent = 'Проверка...';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'confirm_phone_change');
		formData.append('code', code);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Обновляем отображение телефона
				const phoneValue = document.querySelector('.profile-form__phone-value');
				if (phoneValue) {
					phoneValue.textContent = data.new_phone;
				}

				// Закрываем попап
				this.closePhonePopup();
				this.showSuccess('Номер телефона изменён');
			} else {
				btn.disabled = false;
				btn.textContent = 'Подтвердить';
				errorEl.textContent = data.error || 'Неверный код';
			}
		})
		.catch(error => {
			console.error('Verify phone code error:', error);
			btn.disabled = false;
			btn.textContent = 'Подтвердить';
			errorEl.textContent = 'Ошибка соединения';
		});
	},

	// =========================================================================
	// Смена email
	// =========================================================================

	/**
	 * Открыть попап смены email
	 */
	changeEmail: function() {
		const popup = document.getElementById('popup-change-email');
		if (!popup) return;

		// Сброс состояния
		const step1 = document.getElementById('email-step-1');
		const step2 = document.getElementById('email-step-2');
		if (step1) step1.classList.add('popup-change__step--active');
		if (step2) step2.classList.remove('popup-change__step--active');

		// Очистка полей
		const emailInput = document.getElementById('new-email-input');
		if (emailInput) emailInput.value = '';

		const errorEl = document.getElementById('email-change-error');
		if (errorEl) errorEl.textContent = '';

		const codeInput = document.getElementById('email-code-input');
		if (codeInput) codeInput.value = '';

		const codeError = document.getElementById('email-code-error');
		if (codeError) codeError.textContent = '';

		// Показываем попап
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		// Фокус на поле ввода
		setTimeout(() => {
			if (emailInput) emailInput.focus();
		}, 100);
	},

	/**
	 * Закрыть попап смены email
	 */
	closeEmailPopup: function() {
		const popup = document.getElementById('popup-change-email');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
	},

	/**
	 * Отправка кода на новый email
	 */
	sendEmailCode: function() {
		const input = document.getElementById('new-email-input');
		const errorEl = document.getElementById('email-change-error');
		const btn = document.getElementById('email-send-code-btn');

		if (!input) return;

		const newEmail = input.value.trim();
		if (!newEmail) {
			errorEl.textContent = 'Введите email';
			return;
		}

		// Простая валидация email
		if (!newEmail.includes('@') || !newEmail.includes('.')) {
			errorEl.textContent = 'Введите корректный email';
			return;
		}

		errorEl.textContent = '';
		btn.disabled = true;
		btn.textContent = 'Отправка...';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'request_email_change');
		formData.append('new_email', newEmail);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			btn.disabled = false;
			btn.textContent = 'Получить код';

			if (data.success) {
				document.getElementById('email-step-1').classList.remove('popup-change__step--active');
				document.getElementById('email-step-2').classList.add('popup-change__step--active');

				const codeInput = document.getElementById('email-code-input');
				if (codeInput) codeInput.focus();
			} else {
				errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Send email code error:', error);
			btn.disabled = false;
			btn.textContent = 'Получить код';
			errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Вернуться назад в попапе email
	 */
	emailStepBack: function() {
		document.getElementById('email-step-2').classList.remove('popup-change__step--active');
		document.getElementById('email-step-1').classList.add('popup-change__step--active');

		const codeInput = document.getElementById('email-code-input');
		if (codeInput) codeInput.value = '';
	},

	/**
	 * Проверка кода для смены email
	 */
	verifyEmailCode: function() {
		const codeInput = document.getElementById('email-code-input');
		const errorEl = document.getElementById('email-code-error');
		const btn = document.getElementById('email-verify-btn');

		if (!codeInput) return;

		const code = codeInput.value.trim();
		if (!code) {
			errorEl.textContent = 'Введите код';
			return;
		}

		errorEl.textContent = '';
		btn.disabled = true;
		btn.textContent = 'Проверка...';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'confirm_email_change');
		formData.append('code', code);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				const emailValue = document.querySelector('.profile-form__email-value');
				if (emailValue) {
					emailValue.textContent = data.new_email;
				}

				this.closeEmailPopup();
				this.showSuccess('Email изменён');
			} else {
				btn.disabled = false;
				btn.textContent = 'Подтвердить';
				errorEl.textContent = data.error || 'Неверный код';
			}
		})
		.catch(error => {
			console.error('Verify email code error:', error);
			btn.disabled = false;
			btn.textContent = 'Подтвердить';
			errorEl.textContent = 'Ошибка соединения';
		});
	},

	// =========================================================================
	// Утилиты
	// =========================================================================

	// =========================================================================
	// Записи (appointments)
	// =========================================================================

	/**
	 * Переключение вкладок записей
	 */
	switchTab: function(tab) {
		// Обновляем активную вкладку
		document.querySelectorAll('[data-appointments-tab]').forEach(function(el) {
			if (el.dataset.appointmentsTab === tab) {
				el.classList.add('active');
			} else {
				el.classList.remove('active');
			}
		});

		// Показываем/скрываем контент
		var tabs = ['upcoming', 'past', 'canceled'];
		tabs.forEach(function(t) {
			var content = document.getElementById('appointments-tab-' + t);
			if (content) {
				if (t === tab) {
					content.classList.remove('appointments-tab-content--hidden');
				} else {
					content.classList.add('appointments-tab-content--hidden');
				}
			}
		});
	},

	// ID записи, которую отменяем (хранится между открытием попапа и подтверждением)
	_cancelAppointmentId: null,

	/**
	 * Открыть попап подтверждения отмены записи
	 *
	 * @param {number} appointmentId  ID записи
	 * @param {string} date           Дата в формате DD.MM.YYYY
	 * @param {string} timeStart      Время начала HH:MM
	 * @param {string} payStatus      Статус оплаты (оплачено / не оплачено)
	 */
	openCancelPopup: function(appointmentId, date, timeStart, payStatus) {
		var popup = document.getElementById('popup-cancel-appointment');
		if (!popup) return;

		this._cancelAppointmentId = appointmentId;

		// Вычисляем часы до записи
		var parts = date.split('.');
		var timeParts = timeStart.split(':');
		var appointmentDate = new Date(
			parseInt(parts[2], 10),
			parseInt(parts[1], 10) - 1,
			parseInt(parts[0], 10),
			parseInt(timeParts[0], 10),
			parseInt(timeParts[1], 10)
		);
		var hoursUntil = (appointmentDate - new Date()) / (1000 * 60 * 60);
		var isLessThan24h = hoursUntil < 24;
		var isPaid = (payStatus === 'оплачено');

		// Формируем текст подтверждения
		var message = '';
		if (isLessThan24h) {
			message = 'Внимание! При отмене заказа менее чем за 24 часа денежные средства не возвращаются. Всё равно отменить?';
		} else if (isPaid) {
			message = 'Вы уверены, что хотите отменить заказ? Для возврата денежных средств необходимо будет написать заявление или выбрать другую дату.';
		} else {
			message = 'Вы уверены, что хотите отменить заказ?';
		}

		// Сохраняем сценарий для текста результата
		this._cancelScenario = isLessThan24h ? 'less24h' : (isPaid ? 'paid' : 'unpaid');

		// Показываем попап в исходном состоянии
		var messageEl = document.getElementById('cancel-appointment-message');
		var resultEl = document.getElementById('cancel-appointment-result');
		var actionsEl = document.getElementById('cancel-appointment-actions');

		if (messageEl) {
			messageEl.textContent = message;
			messageEl.style.display = '';
		}
		if (resultEl) {
			resultEl.innerHTML = '';
			resultEl.style.display = 'none';
		}
		if (actionsEl) actionsEl.style.display = '';

		popup.classList.add('active');
		document.body.style.overflow = 'hidden';
	},

	/**
	 * Закрыть попап отмены записи
	 */
	closeCancelPopup: function() {
		var popup = document.getElementById('popup-cancel-appointment');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
		this._cancelAppointmentId = null;
		// Обновляем страницу если запись была отменена
		if (this._cancelDone) {
			this._cancelDone = false;
			window.location.reload();
		}
	},

	/**
	 * Подтвердить отмену записи (вызывается из попапа)
	 */
	confirmCancel: function() {
		var appointmentId = this._cancelAppointmentId;
		if (!appointmentId) return;

		var confirmBtn = document.getElementById('cancel-appointment-confirm');
		if (confirmBtn) {
			confirmBtn.disabled = true;
			confirmBtn.textContent = 'Отмена...';
		}

		var self = this;
		var formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'cancel_appointment');
		formData.append('appointment_id', appointmentId);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.success) {
				// Скрываем вопрос и кнопки, показываем результат
				var messageEl = document.getElementById('cancel-appointment-message');
				var resultEl = document.getElementById('cancel-appointment-result');
				var actionsEl = document.getElementById('cancel-appointment-actions');

				if (messageEl) messageEl.style.display = 'none';
				if (actionsEl) actionsEl.style.display = 'none';

				// Текст результата зависит от сценария
				var resultText = '';
				if (self._cancelScenario === 'paid') {
					resultText = 'Ваш заказ отменён! Для возврата денежных средств или переноса записи на другую дату свяжитесь с нами в телеграм <a href="https://t.me/imatonConsult" target="_blank">@imatonConsult</a>';
				} else if (self._cancelScenario === 'less24h') {
					resultText = 'Ваш заказ отменён.';
				} else {
					resultText = 'Ваш заказ отменён!';
				}

				if (resultEl) {
					resultEl.innerHTML = resultText;
					resultEl.style.display = '';
				}

				// Помечаем что нужно обновить страницу при закрытии попапа
				self._cancelDone = true;
			} else {
				// Ошибка — восстанавливаем кнопку
				if (confirmBtn) {
					confirmBtn.disabled = false;
					confirmBtn.textContent = 'Да, отменить';
				}
				alert(data.error || 'Ошибка отмены записи');
			}
		})
		.catch(function(error) {
			console.error('Cancel appointment error:', error);
			if (confirmBtn) {
				confirmBtn.disabled = false;
				confirmBtn.textContent = 'Да, отменить';
			}
			alert('Ошибка соединения');
		});
	},

	/**
	 * Показать сообщение об успехе
	 */
	showSuccess: function(message) {
		const notification = document.createElement('div');
		notification.className = 'profile-notification profile-notification--success';
		notification.textContent = message;
		notification.style.cssText = `
			position: fixed;
			top: 20px;
			right: 20px;
			background: #6bb57f;
			color: white;
			padding: 16px 24px;
			border-radius: 8px;
			font-size: 15px;
			z-index: 10000;
			animation: fadeIn 0.3s ease;
			box-shadow: 0 4px 12px rgba(0,0,0,0.15);
		`;

		document.body.appendChild(notification);

		setTimeout(() => {
			notification.style.opacity = '0';
			notification.style.transition = 'opacity 0.3s';
			setTimeout(() => notification.remove(), 300);
		}, 3000);
	}
};

// Автоинициализация
document.addEventListener('DOMContentLoaded', function() {
	Profile.init();
});

// Экспорт в глобальную область
window.Profile = Profile;
